module.exports = __webpack_public_path__ + "static/media/chs_4.2a37317a.png";